var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"portfolio-page-wrapper"},[_c('BreadCrumbsVue'),_c('DetailCardVue',{on:{"productBread":_vm.setBread}}),_c('OtherWorksVue'),_c('NeedSpecialVue'),_c('InfoBlockVue'),_c('SectionFormVue'),_c('ContactsVue')],1)}
var staticRenderFns = []

export { render, staticRenderFns }